// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-text-results-container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    flex-direction: column;
    border-radius: 8px;
    padding: 20px;
    z-index: 999;

    > img {
        height: 200px;
    }

    p {
        color: var(--on-background);
        font-weight: bold;
    }
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/common-display-images-text-result-grid.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,YAAY;;IAEZ;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;QAC3B,iBAAiB;IACrB;AACJ","sourcesContent":[".image-text-results-container {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n    flex-direction: column;\n    border-radius: 8px;\n    padding: 20px;\n    z-index: 999;\n\n    > img {\n        height: 200px;\n    }\n\n    p {\n        color: var(--on-background);\n        font-weight: bold;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
